const SubmissionApproveStatuses = {
    NOT_APPROVED: 0,
    APPROVED: 1,
    AUTO_APPROVED: 2,
    MISMATCH_APPROVED: 3,
    MISMATCH_CHANGED: 4,
}

export default SubmissionApproveStatuses
